export const dongLabelActiveEvent = (e) => {
  const target = e.target;
  const isActive = target.classList.toggle("active");

  if (target.id === "allDongLabel") {
    const subDongLabels = document.querySelectorAll(".subDongLabel");
    subDongLabels.forEach((label) => {
      label.classList.toggle("active", isActive);
    });
  } else {
    const subDongLabels = document.querySelectorAll(".subDongLabel");
    const allActive = Array.from(subDongLabels).every((label) =>
      label.classList.contains("active")
    );

    const allDongLabel = document.getElementById("allDongLabel");
    if (allActive) {
      allDongLabel.classList.add("active");
    } else {
      allDongLabel.classList.remove("active");
    }
  }
};